import React, { useState } from 'react'
import { Button, InputGroup, Modal } from 'react-bootstrap'
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import DummyMultiPdf from '../../assets/images/dummy/DummyMultiPdf.pdf';
import useWindowSize from '../../hooks/useWindowSize';
import { bucket_url } from '../../constants/const';

const PdfModal = (props) => {
    const { pdf, publication, visible, closeModal } = props;
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    const size = useWindowSize();

    const nextPage = () => {
        setPageNumber((oldPageNumber) => {
            if (oldPageNumber < numPages) {
                return (oldPageNumber + 1)
            }
            return numPages;
        })
    }

    const prevPage = () => {
        setPageNumber((oldPageNumber) => {
            if (oldPageNumber  > 1) {
                return (oldPageNumber - 1)
            }
            return 1;
        })
    }

    const onDocumentLoadSuccess = ({ numPages: nextNumPages }) => {
        if(nextNumPages > 0) {
          setPageNumber(1);
        }
        setNumPages(nextNumPages);
    }

    return (
        <>
            <Modal
                className='publication-reader-modal'
                show={visible}
                onHide={closeModal}
                backdrop="static"
                keyboard={false}
                // dialogClassName="modal-90w"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title className='publication-title'>{publication.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Document className="pdf-container" file={`${bucket_url}${pdf}`} onLoadSuccess={onDocumentLoadSuccess}>
                        {
                        !!pageNumber &&
                        // <Page scale={2.7} key={`page_${pageNumber}`} pageNumber={pageNumber} />
                            <Page key={`page_${pageNumber}`} pageNumber={pageNumber}
                                width={Math.min(size.width * 0.9, 768)}
                            />
                        }
                    </Document>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center w-100">
                        {/* <Button variant="danger" onClick={closeModal}>
                            Close
                        </Button> */}
                        <div className="pdf-control">
                        {
                            numPages > 0 &&
                            <>
                                <InputGroup className="w-100">
                                    <div className='input-group-prepend'>
                                        <Button variant='outline-secondary' onClick={prevPage} size="sm"><FaChevronLeft /> <span className='mr-2'>Prev</span></Button>
                                    </div>
                                    {/* <div className="px-3 py-2 border-top border-bottom d-flex flex-column align-items-center">
                                        <span className=''>{`${pageNumber} / ${numPages}`}</span>
                                        <span><small>page</small></span>
                                    </div> */}
                                    <span className='px-3 py-2 border-top border-bottom bg-light'>{`${pageNumber} / ${numPages}`}</span>
                                    <div className='input-group-append'>
                                        <Button variant='outline-secondary' onClick={nextPage} size="sm"><span className='ml-2'>Next</span> <FaChevronRight /></Button>
                                    </div>
                                </InputGroup>
                            </>
                        }
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default PdfModal